import React from 'react';
import { connect } from 'react-redux';
import Body from '../common/Body';

/**
 * Erorr 404 compoenent return with 404 message
 * @class UnderMaintance
 */
const UnderMaintanance = (props) => (
    <Body>
        <div style={{"margin": "0 auto", "textAlign":"center"}}>
            <h1 style={{"color": "#df2066"}}>Under Maintenance</h1>
            <p style={{"color": "#515151"}}>Thank you for visiting Beauty Bank, <br/><br/>This site is currently under maintenance and should be back shortly. <br/><br/>We apologize for any inconvenience.</p>
        </div>
    </Body>
)
export const mapStateToProps = state => ({

});
export default connect(mapStateToProps)(UnderMaintanance);
